import { FlagDefaults, type ServerFlags } from '@mntn-dev/flags-types'

import { MockModel } from './mock-model.ts'

export const MockServerFlags = MockModel<ServerFlags>(() => {
  return FlagDefaults
})
